<template>
    <div class="icon-alert">
        <div class="icon-alert-left-strip wl-left-panel">
            <div class="icon-alert-icon-wrap">
                <slot name="icon"></slot>
            </div>
        </div>
        <div class="icon-alert-body">
            <div v-if="$slots.heading" class="icon-alert-heading">
                <slot name="heading"></slot>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "IconAlert",
};
</script>

<style scoped>
.icon-alert {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    background-color: #fff;
}

.icon-alert-left-strip {
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 100%;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 10px 0 0 10px;
}

.icon-alert-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 100%;
    padding: 6px 0;
    box-sizing: border-box;
}

.icon-alert-body {
    --icon-alert-gutter: 32px;
    position: relative;
    z-index: 1;
    padding: 20px var(--icon-alert-gutter) 20px calc(60px + var(--icon-alert-gutter));
    box-sizing: border-box;
}

.icon-alert-heading {
    font-size: 2rem;
    font-weight: 600;
    color: #3e3f40;
    line-height: 1.3;
    margin: 0 0 16px 0;
}

.icon-alert-heading >>> * {
    margin: 0;
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
}
</style>

<!-- Slotted icon nodes are compiled in the parent; target them for default strip styling -->
<style>
.icon-alert-left-strip .fa,
.icon-alert-left-strip i {
    color: #fff !important;
    font-size: 1.35em !important;
    line-height: 1 !important;
}
</style>
